import * as React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { integrationRouter } from "@editor/trpc/integration";

import { skipToken } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { IntegrationForm } from "./IntegrationForm";

const IntegrationsEdit = () => {
  const { integrationId } = useParams();
  const projectId = useCurrentProjectId();
  const navigate = useNavigate();
  const shouldSkip = !projectId || !integrationId;

  const { data: integration } = integrationRouter.get.useQuery(
    shouldSkip
      ? skipToken
      : {
          id: integrationId,
          projectId: projectId,
        },
  );

  if (
    !integration ||
    integration.type === "ShopifyIntegrationConfig" ||
    integration.type === "StripeConnect"
  ) {
    return null;
  }

  const { type, config } = integration;

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <IntegrationForm
      integration={type}
      handleCancel={handleCancel}
      initialValues={config}
      integrationId={integrationId}
    />
  );
};

export default IntegrationsEdit;
